export const FETCH_USER = 'fetch_user';
export const LOGIN_USER = 'login_user';
export const LOGOUT_USER = 'logout_user';
